<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
.function {
  padding: 20px 20px 0px;
}
</style>

<template>
  <div class="maintenance-box">
    <div class="panel" v-loading="loading">
      <el-row :gutter="20" class="function">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
          <el-button @click="ajaxHandle" :disabled="btnStatus" style="width: 100%" type="primary" v-text="reuse.refresh"></el-button>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
          <el-button @click="export2Excel(tbodyData, language.excelName)" :disabled="btnStatus" style="width: 100%" v-text="language.nowDownload"></el-button>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" v-loading="dailyLoading">
          <el-button @click="export2EndOfDayExcel" style="width: 100%" v-text="language.endOfDayDownload"></el-button>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
          <el-date-picker :picker-options="pickerOptions" :placeholder="language.placeholder" style="width: 100%" type="date" v-model="dayOfReport"></el-date-picker>
        </el-col>
      </el-row>
      <el-row>
        <custom-table :changeHeight="true" :pageEnable="false" :tableHead="tableHead" :tbodyData="tbodyData"></custom-table>
      </el-row>
    </div>
  </div>
</template>

<script>
import customTable from 'components/reuseTable'
import { URL_SYMBOL_PROFIT } from 'api/api'

const data = () => {
  return {
    tbodyData: [],
    loading: false,
    dailyLoading: false,
    dayOfReport: null,
    btnStatus: false,
    pickerOptions: {
      disabledDate(time) {
        let now = new Date()
        now.setTime(now.getTime() - 24 * 36e5)
        let oneMonthBefore = new Date()
        oneMonthBefore.setTime(oneMonthBefore.getTime() - 31 * 24 * 36e5)
        return time.getTime() > now || oneMonthBefore > time.getTime() || [0, 6].includes(time.getDay())
      },
    },
  }
}

const mixins = [require('common/mixin/base').base({ language: 'symbolProfit' }), require('common/mixin/base').base({ reuse: 'reuse' })]

const computed = {
  tableHead() {
    const redColorColumns = [
        'PREVIOUS_FLOATING_PL','PRESENT_FLOATING_PL','PRESENT_CLOSED_PL','PRESENT_CLOSED_SWAP',
        'PRESENT_NO_COMMISSION_PL','PRESENT_CLOSED_COMMISSION','PRESENT_IB_COMMISSION','PRESENT_PL'
    ]
    this.language.tableHead.forEach(head => {
        if(redColorColumns.includes(head.key)) head.redColor = true;
    })
    return this.language.tableHead
  },
}

const created = function () {
  const userTime = this.$moment()
  const tzOfMT4 = sessionStorage.getItem('MT4TimeZone') || 3
  const tzOfUser = userTime.utcOffset() / 60
  const mt4Time = userTime.add(tzOfMT4 - tzOfUser, 'h')
  const mt4Weekday = mt4Time.weekday()
  const subDays = { 0: 2, 1: 3 }
  this.dayOfReport = mt4Time.subtract(subDays[mt4Weekday] || 1, 'd').format('YYYY-MM-DD')
  if ([0, 6].includes(mt4Weekday)) this.btnStatus = true
  else this.ajaxHandle()
}

const methods = {
  ajaxHandle() {
    this.loading = true
    this.$http
      .post(URL_SYMBOL_PROFIT)
      .then((res) => {
        const useful = res.data.data
        if (Object.prototype.toString.call(useful.data) === '[object Array]') this.tbodyData = useful.data
        else this.tbodyData = []
        this.loading = false
      })
      .catch((e) => {
        alert(this.reuse.serverError)
      })
  },
  export2Excel(datas, excelName) {
    require.ensure([], () => {
      const { export_json_to_excel } = require('@/vendor/Export2Excel')
      const tHeader = this.tableHead.map((v) => v.value)
      const filterVal = this.tableHead.map((v) => v.key)
      const data = datas.map((v) => filterVal.map((j) => v[j]))
      export_json_to_excel(tHeader, data, excelName, { moneyStyle: '#,##0.00;[Red](#,##0.00)' })
    })
  },
  export2EndOfDayExcel() {
    if (this.dayOfReport === null) {
      this.$message.warning(this.language.warning)
      return
    }
    const dayOfReport = this.$moment(this.dayOfReport).format('YYYY-MM-DD')
    this.dailyLoading = true
    this.$http
      .post(URL_SYMBOL_PROFIT, { dayOfReport })
      .then((res) => {
        const useful = res.data.data
        let datas = []
        if (Object.prototype.toString.call(useful.data) === '[object Array]') datas = useful.data
        this.export2Excel(datas, `${dayOfReport}_${this.language.excelName}`)
        this.dailyLoading = false
      })
      .catch((e) => {
        alert(this.reuse.serverError)
      })
  },
}

const components = {
  customTable,
}

export default {
  data,
  mixins,
  computed,
  created,
  methods,
  components,
}
</script>


// WEBPACK FOOTER //
// src/views/manager-report/symbol-profit-report.vue